import styled from 'styled-components';

export const TagContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  gap: 8px;
`;

export const TagContent = styled('div')`
  display: flex;
  align-items: center;
  flex-flow: row nowrap;
  gap: 8px;

  padding: 2px 4px;
  font-size: 12px;
  font-weight: 500px;
  span[role='img'] {
    padding: 6px;
    border-radius: 100%;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition: 0.1s linear;
    }
  }
`;

export const TextActionContainer = styled('div')`
  display: flex;
  flex-flow: column nowrap;
  gap: 8px;

  .ant-tag {
    background-color: #fff;
    cursor: pointer;
  }
`;
